import { StyledButtonLink } from './ButtonLink.styled';
import { ButtonLinkProperties } from './ButtonLink.types';

export function ButtonLink({
    children,
    ...otherProperties
}: ButtonLinkProperties) {
    return <StyledButtonLink {...otherProperties}>{children}</StyledButtonLink>;
}
